export const EVENT_TRIGGER_FIELD = Object.freeze({
  INTENT_NAME: 'intent_name',
  CALL_DURATION: 'call_duration',
  FUNCTION_NAME: 'function_name',
})

export const EVENT_TRIGGER_FIELD_OPTIONS = Object.freeze([
  { value: EVENT_TRIGGER_FIELD.INTENT_NAME, label: '意向标签名称' },
  { value: EVENT_TRIGGER_FIELD.CALL_DURATION, label: '通话时长' },
  { value: EVENT_TRIGGER_FIELD.FUNCTION_NAME, label: '函数名称' },
])

export const EVENT_TRIGGER_OP = Object.freeze({
  EQ: 'eq',
  NEQ: 'neq',
  CONTAINS: 'contains',
  GT: 'gt',
  GTE: 'gte',
  LT: 'lt',
  LTE: 'lte',
})

export const EVENT_TRIGGER_OPS_TEXT = Object.freeze([
  { value: EVENT_TRIGGER_OP.EQ, label: '等于' },
  { value: EVENT_TRIGGER_OP.NEQ, label: '不等于' },
  { value: EVENT_TRIGGER_OP.CONTAINS, label: '包含' },
])

export const EVENT_TRIGGER_OPS_DURATION = Object.freeze([
  { value: EVENT_TRIGGER_OP.GT, label: '大于' },
  { value: EVENT_TRIGGER_OP.LT, label: '小于' },
  { value: EVENT_TRIGGER_OP.GTE, label: '大于等于' },
  { value: EVENT_TRIGGER_OP.LTE, label: '小于等于' },
  { value: EVENT_TRIGGER_OP.EQ, label: '等于' },
])

/** function_name 条件：运算符仅支持等于，且不可修改 */
export const EVENT_TRIGGER_OPS_FUNCTION_NAME = Object.freeze([
  { value: EVENT_TRIGGER_OP.EQ, label: '等于' },
])

export const EVENT_TRIGGER_ACTION = Object.freeze({
  HANGUP: 'hangup',
  COLLAB_REMIND: 'collab_remind',
  SMS: 'sms',
  API_CALL: 'api_call',
})

export const EVENT_TRIGGER_ACTION_OPTIONS = Object.freeze([
  { value: EVENT_TRIGGER_ACTION.HANGUP, label: '挂机' },
  { value: EVENT_TRIGGER_ACTION.COLLAB_REMIND, label: '触发协同提醒' },
  { value: EVENT_TRIGGER_ACTION.SMS, label: '发送短信' },
  { value: EVENT_TRIGGER_ACTION.API_CALL, label: '接口调用' },
])

export const EVENT_TRIGGER_SMS_CHANNELS = Object.freeze([
  { id: 'sms_default', name: '默认短信通道' },
  { id: 'sms_marketing', name: '营销短信通道' },
  { id: 'sms_notify', name: '通知短信通道' },
])

/** 协同提醒坐席类型：内部坐席 / 三方坐席 */
export const EVENT_TRIGGER_COLLAB_SEAT = Object.freeze({
  INTERNAL: 'internal',
  THIRD_PARTY: 'third_party',
})

export const EVENT_TRIGGER_COLLAB_SEAT_OPTIONS = Object.freeze([
  { value: EVENT_TRIGGER_COLLAB_SEAT.INTERNAL, label: '内部坐席' },
  { value: EVENT_TRIGGER_COLLAB_SEAT.THIRD_PARTY, label: '三方坐席' },
])
